<template>
  <div>
    <Dropdown
      :title="`${$lang.reportSettingType} (${$lang.required})`"
      :label="$lang.reportSettingType"
      :placeholder="$lang.reportSettingType"
      :value="form.reportSettingType"
      name="reportSettingType"
      id="reportSettingType"
      :vuelidateObj="$v.form.reportSettingType"
      :asyncSearch="getReportSettingTypeOptions"
      :insideFeature="true"
      @input="input"
      @focus="resetValidation"
      @blur="checkValidation"
    />
    <ResourceUploader
      :url="url"
      :extraPayload="extraPayload"
      :label="$lang.uploadReportFile"
      :cancelButton="true"
      uploaderName="parvandeh_report"
      @close="handleClose"
      @handleReloadList="handleReloadList"
    />
  </div>
</template>

<script>
import inputMixin from "@/mixin/inputMixin.vue";
import { ResourceUploader } from "@/components/re-design";
import { Dropdown } from "@/components/re-design/forms";
import { required } from "vuelidate/lib/validators";
import { pathOr } from "ramda";
import { getReportSettingCombo } from "@/services";
import { generateApiUrl, generateError } from "@/shared/utils";
export default {
  mixins: [inputMixin],
  components: { ResourceUploader, Dropdown },
  props: {
    resourceName: {
      type: String,
      default: "",
    },
    resourceValue: {
      type: [String, Number],
      default: null,
    },
    parvandehCode: {
      type: [String, Number],
      default: null,
    },
  },
  validations() {
    return {
      form: {
        reportSettingType: { required },
      },
    };
  },
  data() {
    return {
      form: {
        reportSettingType: null,
      },
    };
  },
  computed: {
    url() {
      return generateApiUrl(
        ["globalServices", "v2", "uploadResourceReport"],
        [this.resourceName, this.resourceValue]
      );
    },
    extraPayload() {
      return {
        parvandeh_code: this.parvandehCode,
        report_setting_id: pathOr(null, ["reportSettingType", "id"], this.form),
      };
    },
  },
  methods: {
    handleClose() {
      this.$emit("handleClose");
    },
    handleReloadList() {
      this.$emit("handleReloadList");
    },
    async getReportSettingTypeOptions() {
      try {
        this.reportSettingTypeLoading = true;
        const response = await getReportSettingCombo(this.resourceName);
        const { options } = response;
        return options;
      } catch (error) {
        generateError(error);
      } finally {
        this.reportSettingTypeLoading = false;
      }
    },
  },
};
</script>
